export default "__VITE_ASSET__C7YggmH9__"